<template>
  <div class="popup-footer">
    <div class="popup-footer-top">
      <emat-button radius="left" bgColor="blue" @click="goTo(shopUrl)">
        {{ $t('OrderPopupFooterSuccess.continue_shopping') }}
      </emat-button>
      <emat-button radius="right" bg-color="green" @click="goTo(cartUrl)">
        {{ $t('OrderPopupFooterSuccess.to_cart') }}
      </emat-button>
    </div>
    <div class="popup-footer-bottom">
      <span @click="resetConfiguration">
        {{ $t('OrderPopupFooterSuccess.new_charging_station') }}
      </span>
    </div>
  </div>
</template>

<script>
import EmatButton from 'Components/General/Button/index';

export default {
  name: 'OrderPopupFooterSuccess',

  components: {
    EmatButton,
  },

  props: {
    cartUrl: {
      required: true,
      type: String,
    },

    shopUrl: {
      required: true,
      type: String,
    },
  },

  methods: {
    resetConfiguration() {
      this.$store.dispatch('build/initialize');
      this.$store.commit('products/RESET');
      this.$emit('close');
    },

    goTo(url) {
      window.location.href = url;
    },
  },
};
</script>

<style scoped lang="scss">
.popup-footer {
  position: relative;
  padding: 11px 14px;

  &-top {
    display: flex;
    justify-content: space-between;
  }

  &-bottom {
    font-family: $font;
    font-size: 14px;
    cursor: pointer;
    text-align: center;
    color: white;
    position: absolute;
    top: 80px;
    display: block;
    width: 100%;
    left: 0;
    bottom: 0;
    right: 0;
    transition: all ease 0.2s;

    &:hover {
      color: #196CAE;
    }
  }
}
</style>
